import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import withFavorite from 'components/hoc/Cards/withFavorite';
import withHistoryBack from 'components/hoc/Cards/withHistoryBack';

import Card from 'components/molecules/Card';
import cardRenderLocation from 'containers/molecules/Card/enum-card-render-location';

import { generateSignature } from 'helper/signature';

import { getIsFavoriteFromInternalState } from 'store/favorites';
import { getCurrentDayNumber } from 'store/programDays';
import { IconMapTypeType } from 'store/programItems';
import { actionCreators } from 'store/programItems';
import { getCardImageFromItemContent, getExternalIdById, mapBackendContentType } from 'store/programItems';
import { getActiveProgramId } from 'store/programs';
import { getDayRef, getProgramItemRef } from 'store/transientPoolState';

export const mapCategoryIcon = (type: IconMapTypeType) => {
	const iconMap = {
		slogan: 'quote',
		recommendation: 'stars',
		dynamicProduct: 'cart',
	};

	return iconMap[type] ? iconMap[type] : type;
};

const mapStateToProps = (state, ownProps) => {
	const type = mapBackendContentType(ownProps.contentType);
	const categoryIcon = mapCategoryIcon(type);
	const previewImage = getCardImageFromItemContent(ownProps);
	const favorite = getIsFavoriteFromInternalState(state, ownProps.externalId);
	const programItemExternalId = getExternalIdById(state, ownProps.id);
	const programItemRef = getProgramItemRef(state);
	const dayRef = getDayRef(state);
	const currentDayNumber = getCurrentDayNumber(state);
	const signature = generateSignature(
		dayRef,
		programItemRef,
		ownProps.externalId,
		categoryIcon,
		ownProps.masterChannel,
		previewImage,
		favorite
	);

	return {
		...ownProps,
		signature,
		id: ownProps.externalId,
		programItemExternalId,
		contentTypeExternalId: ownProps.externalId,
		state: 'feed',
		uiState: 'detail',
		previewImage,
		favorite,
		type,
		categoryIcon,
		isMigustoRecipe: ownProps.masterChannel === 'migusto',
		isCheckable: false,
		cardRenderLocation: cardRenderLocation.POOL,
		programItemRef,
		dayRef,
		currentDayNumber,
		programId: getActiveProgramId(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doToggleFavorite: actionCreators.doToggleFavorite,
			doSwapItem: actionCreators.doSwapItem,
		},
		dispatch
	);
};

const CardWithHistory = withHistoryBack(Card);
const CardWithFavorite = withFavorite(CardWithHistory);

export default connect(mapStateToProps, mapDispatchToProps)(CardWithFavorite);
